import { apiRequest } from './api';

function getAuthHeaders() {
  try {
    const token = window.localStorage.getItem('chse_auth_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

export async function getFilterOptions(params) {
  const searchParams = new URLSearchParams();
  if (params?.categoryId) {
    searchParams.set('category_id', String(params.categoryId));
  }

  const query = searchParams.toString();
  const endpoint = query ? `/api/filter_options?${query}` : '/api/filter_options';

  return apiRequest(endpoint, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
}
